module.exports = __webpack_public_path__ + "img/img1.7976c4a4.jpg";